var exports = {
  "kL": "GuildIcon.module__container___bndGRE",
  "qJ": "GuildIcon.module__containerNoIcon___bndGRE",
  "yC": "GuildIcon.module__initials___bndGRE",
};

module.exports = exports;
